module.exports = __webpack_public_path__ + "img/mantap-berhijrah.8f8a6b2b.png";